import { useState, useEffect } from "react";
import "./CalculationProperties.css";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "semantic-ui-react";
import { Loading } from "../../components/Loading/Loading";
import { ICalculation } from "../../models/calculation";
import { getCalculation } from "../../services/calculationsService";
import { TimestampsDict } from "../../store/timestampsReducer";
import { CalcPropsGeneralInfo } from "./Props/CalcPropsGeneralInfo";
import { CalcPropsVertices } from "./Props/CalcPropsVertices";
import { CalcPropsCCValidation } from "./Props/CalcPropsCCValidation";
import { CalcPropsManualNECs } from "./Props/CalcPropsManualNECs";
import { CalcPropsNPShifts } from "./Props/CalcPropsNPShifts";
import { CalcPropsRAOReport } from "./Props/CalcPropsRAOReport";
import { CalcPropsAdditionalOutage } from "./Props/CalcPropsAdditionalOutage";
import { CalcPropsVerticesLimits } from "./Props/CalcPropsVerticesLimits";

export const CalculationProperties = () => {
    const navigate = useNavigate();
    const params: { guid?: string } = useParams();
    const [calculation, setCalculation] = useState<ICalculation>();

    useEffect(() => {
        getCalculation(params.guid ?? "").then(res => {
            if (!res.additionalData?.includes("TYPE=2")) {
                const subtaskMessage = JSON.parse(res.subtasks[0].message);
                const messageCalcProps = subtaskMessage.CalcProps
                    ? JSON.parse(subtaskMessage.CalcProps)
                    : JSON.parse(subtaskMessage.calcProps);
                const calc: ICalculation = JSON.parse(messageCalcProps.jsonString);
                const vertices: TimestampsDict = {};
                res.subtasks.forEach(subtask => {
                    const message = JSON.parse(subtask.message);
                    const hour = message.hour ? +message.hour : +message.Hour;
                    const calcProps = message.CalcProps
                        ? JSON.parse(message.CalcProps)
                        : JSON.parse(message.calcProps);
                    const json = JSON.parse(calcProps.jsonString);
                    const hourVertices: number[] = json.vertices;
                    vertices[hour] = hourVertices;
                });
                calc.vertices = vertices;
                setCalculation(calc);
            }
        });
    }, [params.guid]);

    return (
        <div id="calculation-properties-page-container-div" className="calculation-properties-page-container">
            <div id="calculation-properties-page-title-div-a" className="calculation-properties-page-title tsc-blue">
                <h1 id="calculation-properties-page-title">Calculation properties</h1>
                <Button
                    id="button-calculation-properties-a"
                    primary
                    content="Back to list of calculations"
                    onClick={() => navigate("/Study")}
                />
            </div>
            <div id="calculation-properties-page-content-div" className="calculation-properties-page-content">
                {!calculation ? (
                    <Loading />
                ) : (
                    <div id="calculation-properties-display-container">
                        <CalcPropsGeneralInfo calculation={calculation} />
                        <CalcPropsVertices calculation={calculation} />
                        <CalcPropsCCValidation calculation={calculation} />
                        <CalcPropsManualNECs calculation={calculation} />
                        <CalcPropsNPShifts calculation={calculation} />
                        <CalcPropsVerticesLimits calculation={calculation} />
                        <CalcPropsAdditionalOutage calculation={calculation} />
                        <CalcPropsRAOReport calculation={calculation} />
                    </div>
                )}
            </div>
        </div>
    );
};
